import { useNavigate, useLocation } from "react-router-dom";

import "./sidebar.css";

import {
  MyCoursesIcon,
  MyCoursesIconActive
} from "./Icons";

function TeacherDashboardItem(props) {
  const { Icon, path, text, active } = props;
  const navigate = useNavigate();
  function onClick() {
    navigate(path);
  }

  function getClassName() {
    if (active)
      return "DashboardSidebarItem DashboardSidebarItemActive"
    return "DashboardSidebarItem";
  }

  return (
    <div className={getClassName()} onClick={onClick}>
      <div className="DashboardSidebarItemIcon">
        <Icon />
      </div>
      <div className="DashboardSidebarItemText">
        {text}
      </div>
    </div>
  )
}

function isMyCoursesPathname(pathname) {
  const path = pathname.split("/")
  const len = path.length;
  if (len >= 3 && (path[1] === "teacher" && path[2] === "dashboard")) {
    return true;
  }
  if (len >= 3 && (path[1] === "teacher" && path[2] === "courses")) {
    return true;
  }
  if (len >= 5 && (path[1] === "teacher") && path[2] === "lessons") {
    return true;
  }
  
  return false;
}

function TeacherDashboardItems() {
  const { pathname } = useLocation();
  const items = [
    {
      Icon: isMyCoursesPathname(pathname) ? MyCoursesIconActive : MyCoursesIcon,
      path: "/teacher/dashboard",
      text: "My Courses",
      active: isMyCoursesPathname(pathname),
    },
  ]

  return (
    <div className="DashboardSidebarItems">
      {items.map((_props) => <TeacherDashboardItem {..._props} />)}
    </div>
  )
}

function TeacherSidebar() {
  return (
    <div className="DashboardSidebar">
      <div className="DashboardSidebarLogoContainer">
        <div className="DashboardSidebarLogo" />
      </div>
      <TeacherDashboardItems />
    </div>
  )
}

export default TeacherSidebar;
